import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NoteType {
  id?: number;
  note?: string;
}

export interface VoucherType {
  id?: number;
  provider?: string;
  amount?: number;
}

export interface MordyType {
  id?: number;
  amount?: number;
  hatzalah?: boolean;
}

export interface DiscountType {
  id?: number;
  amount?: number;
}

export interface OrderType {
  id?: number;
  customerId?: number;
  userId?: number;
  status?: string;
  paymentType?: string;
  note?: NoteType;
  voucher?: VoucherType;
  mordy?: MordyType;
  discount?: DiscountType;
  total?: number;
  tax?: string;
}

export const initialState: OrderType = {};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setOrder: (state: OrderType, action: PayloadAction<OrderType>) => ({
      ...state,
      ...action.payload,
    }),
    setPaymentType: (state: OrderType, action: PayloadAction<string>) => ({
      ...state,
      paymentType: action.payload,
    }),
    updateOrderStatus: (state: OrderType, action: PayloadAction<string>) => ({
      ...state,
      status: action.payload,
    }),
    updateOrderNote: (state: OrderType, action: PayloadAction<NoteType>) => ({
      ...state,
      note: action.payload,
    }),
    updateOrderVoucher: (state: OrderType, action: PayloadAction<VoucherType>) => ({
      ...state,
      voucher: action.payload,
    }),
    updateOrderMordy: (state: OrderType, action: PayloadAction<MordyType>) => ({
      ...state,
      mordy: action.payload,
    }),
    updateOrderDiscount: (state: OrderType, action: PayloadAction<DiscountType>) => ({
      ...state,
      discount: action.payload,
    }),
    resetNote: (state: OrderType) => ({
      ...state,
      note: {},
    }),
    resetVoucher: (state: OrderType) => ({
      ...state,
      voucher: {},
    }),
    resetMordy: (state: OrderType) => ({
      ...state,
      mordy: {},
    }),
    resetDiscount: (state: OrderType) => ({
      ...state,
      discount: {},
    }),
    resetOrder: () => initialState,
  },
});

export const {
  setOrder,
  setPaymentType,
  updateOrderStatus,
  updateOrderVoucher,
  updateOrderMordy,
  updateOrderNote,
  updateOrderDiscount,
  resetOrder,
  resetNote,
  resetVoucher,
  resetDiscount,
  resetMordy,
} = orderSlice.actions;

export default orderSlice.reducer;
